module.exports = __webpack_public_path__ + "static/media/Tumblr.85149f49.svg";